export const EIssueSeverity = {
    critical: 4,
    important: 3,
    moderate: 2,
    clean: 1,
} as const

export const SEVERITY_LEVELS: Array<Exclude<TIssueSeverity, 'clean'>> = [
    'critical',
    'important',
    'moderate',
]

type ErrorType =
    | 'permissionsError'
    | 'encryptionError'
    | 'generalApiError'
    | 'maxUsersExceeded'
export const keyErrorInfo: Record<
    ErrorType,
    { key?: string; message: string; errors?: Record<string, string> }
> = {
    permissionsError: {
        key: 'PERMISSIONS_ERROR',
        message:
            'Insufficient privileges - the integration can only be enabled by users with one of the following roles:\n' +
            'Super Admin or Directory Sync Admin',
    },
    encryptionError: {
        message: 'Unable to enable integration. Please try again later.',
    },
    generalApiError: {
        message:
            'Request failed, please try again in a few moments, if an error keeps occurring, please reach out in the chat',
    },
    maxUsersExceeded: {
        key: 'MAX_USERS_EXCEEDED',
        message:
            'Your Microsoft 365 account exceeds the 10,000 mailbox limit, causing the connection to fail. Please contact support via chat.',
    },
}

export const EMAIL_REGEX =
    /^(?!.*\.{2})[A-Z0-9](?:[A-Z0-9._%+-]{0,62}[A-Z0-9])?@(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,}$/i

export const ISSUE_STATUS_MAPPING: Record<TIssueStatus, string> = {
    open: 'open',
    resolved: 'resolved',
    approved: 'approved',
    in_review: 'in review',
}
